

export default {
	testToken:"ff",
	token:'',
}